import React from 'react';

import './loadingSpinner.scss';

export const LoadingSpinner = () => (
  <span className="loading-spinner" />
);
